import { computed, defineAsyncComponent, defineComponent } from "vue";
import { useRoute } from "vue-router";
/** Async: App import sırasında chat→api→auth döngüsünü tetiklememek için. */
const ChatWidget = defineAsyncComponent(() => import("@/chat/ChatWidget.vue"));
export default defineComponent({
    name: "App",
    components: { ChatWidget },
    setup() {
        const route = useRoute();
        const showChat = computed(() => !route.meta.hideChat);
        return { showChat };
    },
});
